
import {
    DxDataGrid,
    DxEditing,
    DxColumn,
    DxPaging,
    DxLookup,
    DxForm,
    DxFilterRow,
    DxSearchPanel,
    DxScrolling,
    DxPager,

} from 'devextreme-vue/data-grid';
import { DxItem } from 'devextreme-vue/form';
import { DxToast } from 'devextreme-vue/toast';
import 'devextreme-vue/text-area';


import ServicioGrupoListadoInformacionService from '../services/serviciogrupolistadoinformacion-service';
import GrupoListadoInformacionService from '../services/grupolistadoinformacion-service';



export default {
    components: {
        DxDataGrid,
        DxColumn,
        DxPaging,
        DxEditing,
        DxLookup,
        DxForm,
        DxItem,
        DxFilterRow,
        DxSearchPanel,
        DxScrolling,
        DxPager,
        DxToast,

    },
    props: {
        supplierId: {
            type: Number,
            default: null,
        },
    },
    data() {

        return {

            procedimientos: null,
            dataSourceGrupo: null,
            dataSourceSolicitudServicio: null,
            allowedPageSizes: [5, 10, 20, 50, 'all'],
            showInfo: true,
            showNavButtons: true,
            isVisible: false,
            message: '',
            type: 'info',
            popupOptions: {
                title: 'Listado de Informacion',
                showTitle: true,
                width: 350,
                height: 220,
            },



        };
    },
    created() {

        this.serviciogrupolistadoinformacionService = new ServicioGrupoListadoInformacionService();
        this.grupolistadoinformacionService = new GrupoListadoInformacionService();

    },
    mounted() {

        this.loadDataInfo();
    },
    methods: {
        loadDataInfo() {
            let id = this.supplierId;
            let myJSON = JSON.stringify({
                pid: id
            });


            this.serviciogrupolistadoinformacionService.getServicioGrupoListadoInformacion(myJSON).then(data => this.dataSourceSolicitudServicio = data);
            this.grupolistadoinformacionService.getGrupoListadoInformacion().then(data => this.dataSourceGrupo = data);
        },

        deleteRegister(e) {

            let myJSON = JSON.stringify({
                pid: e.data.id,
            });


            this.serviciogrupolistadoinformacionService.deleteServicioGrupoListadoInformacion(myJSON).then(data => {

                if (data.err == 0) {
                    this.type = 'success';
                    this.message = 'Se ha eliminado el registro';
                    this.isVisible = true;
                    this.loadDataInfo();
                } else {

                    this.type = 'error';
                    this.message = 'Ocurrio un error ' + data.msg;
                    this.isVisible = true;

                }


            });

        },
        createRegister(e) {


            let id = this.supplierId;

            let myJSON = JSON.stringify({
                pgrupolistadoinformacionid: e.data.grupolistadoinformacionid,
                pservicioid: id,
            });



            this.serviciogrupolistadoinformacionService.createServicioGrupoListadoInformacion(myJSON).then(data => {

                if (data.err == 0) {
                    this.type = 'success';
                    this.message = 'Se ha creado el registro';
                    this.isVisible = true;
                    //this.loadDataInfo();
                } else {

                    this.type = 'error';
                    this.message = 'Ocurrio un error ' + data.msg;
                    this.isVisible = true;
                    // this.loadDataInfo();
                }
                this.loadDataInfo();

            });


        },
        onSaved() {
            if (this.retryButtonVisible) {
                this.retryButtonVisible = false;
            }
        },
        onEditCanceled() {
            if (this.retryButtonVisible) {
                this.retryButtonVisible = false;
            }
        },
        logEvent(eventName) {
            this.events.unshift(eventName);
        }
        ,
    },
};
